import React, { ReactNode } from "react";
import styled from "styled-components";
import { colors, fontSizing, font, media, gradientBackground } from "../theme";
import Content from "../common/Content";
import Filter from "./SegmentFilter";
import SearchInput from "./AutocompleteSearchInput";
import { TAB_HEIGHT } from "../common/tabs";
import { generateAutoPlacementForIE } from "../common/Grid";

const Container = styled.header`
  ${gradientBackground};
  padding-bottom: ${TAB_HEIGHT}px;
  @media ${media.mobile} {
    padding-bottom: 0;
  }
`;

const SearchWrapper = styled.div<{ children: ReactNode | ReactNode[] }>`
  white-space: nowrap;
  align-items: center;
  padding: calc(4px * 14) 0;
  display: -ms-grid;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-auto-rows: auto;
  grid-row-gap: calc(4px * 7);
  ${p =>
    generateAutoPlacementForIE(p.children, "1fr 2fr", {
      column: 0,
      row: 4 * 7
    })}
  ${fontSizing("headline", 32)};
  font-family: ${font.main};
  @media ${media.mobile} {
    grid-template-columns: 1fr;
    padding: calc(4px * 7) 0;
    ${p =>
      generateAutoPlacementForIE(p.children, "1fr", { column: 0, row: 4 * 7 })}
  }

  @media screen and ${media.superTinyZoom125} {
    white-space: initial;
    word-break: break-word;
    hyphens: auto;
  }
`;

const DesktopSpacer = styled.div`
  @media ${media.mobile} {
    display: none;
  }
`;

const Headline = styled.h1`
  color: ${colors.white};
  margin: 0;
  margin-right: calc(4px * 14);
  ${fontSizing("headline", 32)}
  @media ${media.mobile} {
    margin: 0;
    font-size: 18px;
  }
`;

interface Props {
  activeTab: string;
  searchTerm: string;
  checkedSegments?: string[];
}
export default function Header(props: Props) {
  const { activeTab, searchTerm } = props;

  return (
    <Container>
      <Content padded>
        <SearchWrapper>
          <Headline id="autocomplete-search-label">
            Ihr Suchergebnis zu
          </Headline>
          <SearchInput term={searchTerm} />
          <DesktopSpacer />
          {activeTab === "foerderprogramme" && (
            <Filter lightTheme checkedSegments={props.checkedSegments} />
          )}
        </SearchWrapper>
      </Content>
    </Container>
  );
}
